// IMPORTS GO HERE
import _ from 'underscore';
import $ from 'jquery';
import collectDataAttributesFor from "../collectDataAttributesFor";
import render from "../render";
import moment from 'moment';
const standardDatePickerHtml = require('./html/singleDatePicker.html');
const rangeDatePickerHtml = require('./html/rangeDatePicker.html');

// rename to match what this utility is...
export default function generateDatePicker(els) {
  // functional code for utility here
  els.each(function(){
    const el = this;
    const $el = $(this);
    const defaults = {
      todayBtn: 'linked',
      keyboardNavigation: false,
      autoclose: true
    }
    const options = collectDataAttributesFor(el, {prefix: "dp"});
    
    const settings = _.extend(defaults, options);
    
    const type = settings.type;

    const startVal = settings.startVal;
    const endVal = settings.endVal;
    
    if(settings.startDate == 'today'){
      settings.startDate = moment().format('MM/DD/YYYY');
    }
    
    if(type == 'single'){
      $el.html(render(standardDatePickerHtml,{
        uniqueIdentifier: settings.uniqueIdentifier
      }));
    }
    
    if(type == 'range'){
      $el.html(render(rangeDatePickerHtml,{
        uniqueIdentifier: settings.uniqueIdentifier,
      }));
    }
    
    let standardDatePickerEL = $el.find(`.${settings.uniqueIdentifier}`),
        rangeDatePickerStartEl = $el.find(`.${settings.uniqueIdentifier}-start`),
        rangeDatePickerEndEl = $el.find(`.${settings.uniqueIdentifier}-end`);
    
    standardDatePickerEL.datepicker(settings);
    rangeDatePickerStartEl.datepicker(settings).on('hide', ()=>{
      if(!rangeDatePickerStartEl.val().length){
        resetRangeEndDateEl();
      }
    });
    resetRangeEndDateEl();
    
    rangeDatePickerStartEl.on('change',()=>{
      const oldStartDate = rangeDatePickerStartEl.val();
      if(oldStartDate.length){
        const newStartDate = new Date(Date.parse(oldStartDate) + 86400000);
        settings.startDate = formatDate(newStartDate);
        rangeDatePickerEndEl.removeAttr('disabled');
        rangeDatePickerEndEl.val('');
        rangeDatePickerEndEl.datepicker('remove');
        rangeDatePickerEndEl.datepicker(settings);
      } else {
        resetRangeEndDateEl();
      }
    });
    
    function formatDate(date) {
      let day = date.getDate(),
          month = date.getMonth()+1,
          year = date.getFullYear();
      return `${month}/${day}/${year}`;
    }

    if(type == 'single' && startVal){
      standardDatePickerEL.val(startVal);
    }

    if(type == 'range' && startVal || endVal){
      rangeDatePickerStartEl.val(startVal);
      rangeDatePickerEndEl.val(endVal);
      rangeDatePickerEndEl.removeAttr('disabled');
      rangeDatePickerEndEl.datepicker(settings);
    }

    function resetRangeEndDateEl(){
      rangeDatePickerEndEl.attr('disabled', 'disabled');
      rangeDatePickerEndEl.val('');
      rangeDatePickerEndEl.datepicker('remove');
    }
        
  });
};


// WEBPACK FOOTER //
// ./src/utilities/datePicker/index.js